import { Target, Users, Compass } from "lucide-react";
import { Link } from "react-router-dom";
import Navigation from "@/components/Navigation";

const Explore = () => {
  const exploreItems = [
    { 
      icon: Target, 
      label: "Challenges", 
      path: "/challenges",
      color: "bg-orange-500/10 text-orange-500",
      description: "Daily skill challenges"
    },
    { 
      icon: Users, 
      label: "Learning Circles", 
      path: "/circles",
      color: "bg-green-500/10 text-green-500",
      description: "Join learning groups"
    },
  ];
  
  return (
    <div className="min-h-screen bg-background pb-24">
      {/* Header */}
      <header className="gradient-primary text-white p-6 pb-8 rounded-b-3xl shadow-strong">
        <div className="container max-w-md mx-auto">
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <Compass className="h-6 w-6" />
            Explore
          </h1>
          <p className="text-white/80 text-sm mt-1">Discover more features</p>
        </div>
      </header>

      {/* Main Content */}
      <main className="container max-w-md mx-auto px-4 -mt-4">
        <div className="grid grid-cols-2 gap-4">
          {exploreItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className="bg-card rounded-2xl p-6 shadow-soft hover:shadow-strong transition-all hover:scale-105 flex flex-col items-center text-center gap-3"
              >
                <div className={`p-4 rounded-xl ${item.color}`}>
                  <Icon className="h-8 w-8" />
                </div>
                <div>
                  <p className="font-semibold text-foreground">{item.label}</p>
                  <p className="text-xs text-muted-foreground mt-1">{item.description}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </main>

      <Navigation />
    </div>
  );
};

export default Explore;